function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'red': 'rgb(213, 189, 229)','beige': 'rgb(243, 232, 216)','light-blue': 'rgb(211, 170, 170)','violet': 'rgb(179, 159, 205)','white': 'rgb(255, 255, 255)','lilac': 'rgb(220, 213, 217)','red': 'rgb(255, 0, 0)','green': 'rgb(0, 128, 0)','blue': 'rgb(81, 123, 173)','black': 'rgb(0, 0, 0)','dark-blue': 'rgb(0, 0, 139)','dark-brown': 'rgb(76, 42, 18)','light-brown': 'rgb(180, 125, 73)','yellow': 'rgb(255, 255, 0)','navy-blue': 'rgb(0, 0, 139)','red-and-black': 'rgb(255, 0, 0)','black-and-red': 'rgb(0, 0, 0)','pink': 'rgb(255, 0, 127)','orange': 'rgb(255, 138, 0)','black-and-white': 'rgb(255, 255, 255)','black-and-gold': 'rgb(255, 215, 0)','light-green': 'rgb(152, 251, 152)','olive-green': 'rgb(128, 128, 0)','blue-and-black': 'rgb(81, 123, 173)','gray-and-black': 'rgb(128, 128, 128)','beige': 'rgb(245, 245, 220)','dark-green': 'rgb(0, 100, 0)','gray': 'rgb(128, 128, 128)','orange': 'rgb(255, 138, 0)','burgundy': 'rgb(114, 47, 55)','off-white': 'rgb(250, 249, 246)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
